import * as Actions from './PhoneEntryPageActions';

const defaultState = {
    phoneNumberFormatted: '',
    sendingPhoneNumber: false,
    sendPhoneNumberError: null,
};

export const phoneEntryPageReducer = (state = defaultState, action) => {
    switch (action.type) {
        case Actions.CHANGE_PHONE_NUMBER: {
            return {
                ...state,
                phoneNumberFormatted: action.phoneNumber,
            };
        }

        case Actions.SEND_PHONE_NUMBER: {
            return {
                ...state,
                sendingPhoneNumber: true,
                sendPhoneNumberError: false,
            };
        }

        case Actions.SEND_PHONE_NUMBER_SUCCESS: {
            return {
                ...state,
                sendingPhoneNumber: false,
            };
        }

        case Actions.SEND_PHONE_NUMBER_FAILURE: {
            return {
                ...state,
                sendingPhoneNumber: false,
                sendPhoneNumberError: action.error,
            };
        }

        default:
            return state;
    }
};
